<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('eartag.Check_confirm') }}</h5>    
    <div class="multisteps-form__content">
      <div class="row mt-3">
         <div class="col-8 mb-3">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('eartag.Keeper') }}</label>
              <div class="display-field" v-html="localFormData.keeperDetails"></div>
            </div>
        </div>
        <div class="col-8 mb-3">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('eartag.Animal') }}</label>
              <div class="display-field" v-html="localFormData.animalDetails"></div>
            </div>
        </div>
        <div class="col-8 mb-3">
            <div class="input-group input-group-static null">
                <label>{{ $t('eartag.Tag') }}</label>
                <div class="display-field" v-html="localFormData.tagDetails"></div>
            </div>
        </div>
        <div class="col-8 mb-3">
            <div class="input-group input-group-static null">
                <label>{{ $t('eartag.Date') }}</label>
                <div class="display-field">{{ formatDate(localFormData.reTagDate) }}</div>                
            </div>
        </div>
      </div>            
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="validateAndPrevStep">{{ $t('common.Prev') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
  import { reactive, watch } from 'vue'
  
  export default {
    name: "ConfirmInfo",
    props: {      
      formData: Object,
      prevStep: Function,
      nextStep: Function
    },
    setup(props, { emit }) {      
      const localFormData = reactive(props.formData);

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndPrevStep = async () => {
          props.prevStep()
      }

      const validateAndSubmit = async () => {        

        console.log('here');

        Object.assign(props.formData, localFormData)
        emit('submit')
        return true        
      }     

      const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      }

      return {
        localFormData,
        formatDate,               
        validateAndPrevStep,
        validateAndSubmit
      }
    }    
};
</script>
<style scoped>
.display-field {
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #4ca750;
  padding: 2px 0;
  margin-top: 2px;
  background-color: transparent;  
  font-size: 0.875rem;
}
.card {
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  position: relative;
  padding: 10px !important;
}
.cursor-pointer {
  cursor: pointer;
}
.bg-light {
  background-color: #f9f9f9 !important;
}
.border-success {
  border-color: #28a745 !important;
}
</style>